<div
    class="agpr-influencerStream-container"
    role="feed"
    tabindex="0"
    [attr.aria-labelledby]="'influencerStream_' + index + '_headerName_sr'"
    (keydown)="onKeydown($event)"
>
    <h2 class="u-srOnly" [id]="'influencerStream_' + index + '_headerName_sr'">
        {{ 'Discover.influencerStreams.streamHeader' | localize: {
            name: selectedSource ? selectedSource?.name : _stream.keyphrase,
            type: selectedSourceType.label,
            index: index + 1,
            length: streamsLength
        } }}
    </h2>

    <div
        *ngIf="!_stream.editing"
        class="agpr-influencerStream-header"
    >
        <span
            *ngIf="selectedSourceType.value === 'keyword'"
            class="agpr-influencerStream-header-typeIcon fa-solid fa-file-magnifying-glass"
            aria-hidden="true"
        >
        </span>
        <span
            *ngIf="selectedSourceType.value === sourceTypeEnum.searches"
            class="agpr-influencerStream-header-typeIcon fa-solid fa-floppy-disk"
            aria-hidden="true"
        >
        </span>
        <span
            *ngIf="selectedSourceType.value === sourceTypeEnum.lists"
            class="agpr-influencerStream-header-typeIcon fa-kit fa-agpr-lists-solid"
            aria-hidden="true"
        >
        </span>
        <div
            class="agpr-influencerStream-header-name"
            [id]="'influencerStream.' + index + '.headerName'"
        >
            <span *ngIf="_stream.keyphrase">{{_stream.keyphrase}}</span>
            <span>{{selectedSource?.name}}</span>
        </div>
    </div>

    @if (_stream.editing) {
        <div class="agpr-influencerStream-toolbarContainer" role="group" [attr.aria-label]="'Discover.influencerStreams.controls' | localize">
            <div class="agpr-influencerStream-toolbarHeader">
                {{ 'Discover.influencerStreams.toolbarHeading' | localize }}
            </div>
            <div class="agpr-influencerStream-sourcePicker-dropdown-container">
                <agpr-dropdown
                    class="agpr-influencerStream-sourcePicker-dropdown top"
                    [id]="'influencerStream.' + index + '-sourceTypeDropdown'"
                    label="Discover.influencerStreams.sourceSelection"
                    [options]="sourceTypes"
                    [(ngModel)]="selectedSourceType"
                    (ngModelChange)="sourceTypeChanged()"
                    ariaLabel="Discover.influencerStreams.selectSourceLabel"
                >
                </agpr-dropdown>

                @if (selectedSourceType?.value == 'keyword') {
                    <agpr-text-input
                        [id]="'influencerStream.' + index + 'keywordInput'"
                        class="agpr-influencerStream-sourcePicker-dropdown bottom"
                        [ariaLabel]="'Discover.influencerStreams.keyword'"
                        [bottomMargin]="false"
                        [(ngModel)]="_stream.keyphrase"
                        (keydown)="keywordInputKeydown($event)"
                        [maxLength]="255"
                        [placeholder]="sourceSelectorPlaceholder"
                    ></agpr-text-input>
                } @else {
                    <agpr-autocomplete
                        [id]="'influencerStream.' + index + 'sourceDropdown'"
                        class="agpr-influencerStream-sourcePicker-dropdown bottom"
                        labelField="name"
                        [placeholder]="sourceSelectorPlaceholder"
                        [dropdown]="true"
                        [ngModel]="selectedSource"
                        (ngModelChange)="sourceChanged($event)"
                        [suggestions]="sources$"
                        [clearOnBlur]="false"
                        [ariaLabel]="sourceSelectorPlaceholder"
                        [showHiddenOption]="true"
                    ></agpr-autocomplete>
                }
            </div>
            <div
                class="agpr-influencerStream-sourcePicker-filter"
                [ngClass]="{'hasChips': chipsVisible}"
            >
                <agpr-filter-dropdown
                    [id]="'influencerStream.' + index + 'sourceFilter'"
                    [showQuickFilter]="true"
                    quickFilterPlaceholder="Discover.influencerStreams.sourceSelection.filter.placeholder"
                    [disabled]='!selectedSource && (selectedSourceType.value === sourceTypeEnum.searches || selectedSourceType.value === sourceTypeEnum.lists)'
                    [ariaLabel]="'Discover.influencerStreams.sourceSelection.filter.placeholder' | localize"
                    [ariaDescribedBy]="'influencerStream.sourceFilter.chips'"
                >
                </agpr-filter-dropdown>
            </div>
            @if (chipsVisible) {
                <div class="agpr-influencerStream-sourcePicker-chips-container">
                    <agpr-filter-chips
                        [id]="'influencerStream_' + index + '_sourceFilter_chips'"
                    ></agpr-filter-chips>
                </div>
            }

            @if (selectedSource || _stream.keyphrase) {
                <div class="agpr-influencerStream-sourcePicker-images">
                    <agpr-button
                        [label]="_stream.showImages ? 'Discover.influencerStreams.hideImages' : 'Discover.influencerStreams.showImages'"
                        [style]="buttonTypes.textToggle"
                        [id]="'influencerStream_' + index + '_imageToggle'"
                        (click)="toggleImageExpansion()"
                    ></agpr-button>
                </div>
            }

            @if (_stream.id) {
                <div class="agpr-influencerStream-sourcePicker-reset">
                    <agpr-button
                        label="Discover.influencerStreams.resetStream"
                        [style]="buttonTypes.tertiary"
                        id="influencerStream_{{ index }}_resetStreamButton"
                        (click)="resetStream()"
                    ></agpr-button>
                </div>
            }

            <div class="agpr-influencerStream-sourcePicker-buttons">
                <agpr-button
                    [style]="buttonTypes.secondary"
                    label="Core.button.cancel"
                    tooltip="close"
                    [expanded]="true"
                    (click)="closeToolbar()"
                ></agpr-button>
                <agpr-button
                    label="Core.button.apply"
                    [style]="buttonTypes.primaryB"
                    id="influencerStream_{{ index }}_applyButton"
                    (click)="apply()"
                    [disabled]='!this.selectedSource && !_stream.keyphrase'
                ></agpr-button>
            </div>
        </div>
    } @else {
        <agpr-scroll-panel
            (scrolledToBottom)="fetchOlderMentions()"
        >
            <h3 class="u-srOnly">{{ 'Discover.influencerStreams.streamResults' | localize }}</h3>
            <agpr-message
                *ngIf="visibleMentions && visibleMentions.length === 0 && (hiddenMentions.length === 0) && !loading && !showWarningMessage"
                [severity]="messageSeverities.noContent"
                [useWhiteBg]="true"
            >
                {{'Discover.influencerStreams.noCoverage' | localize}}
            </agpr-message>
            <div
                *ngIf="hiddenMentions.length > 0"
                class="agpr-influencerStream-viewMore"
            >
                <agpr-button
                    id="{{ index }}_leftSidebar_showAllHidden"
                    class="agpr-influencerStream-viewMore-link"
                    [style]="buttonTypes.link"
                    [label]="'Discover.influencerStreams.viewNew' | localize : { count: hiddenMentions.length }"
                    (click)="revealMentions()"
                ></agpr-button>
            </div>
            <agpr-message
                *ngIf="showWarningMessage && !loading"
                class="agpr-influencerStream-sizeLimitWarning"
                [severity]="messageSeverities.warning"
            >
                {{ 'Discover.influencerStreams.sizeLimitWarning' | localize: {limit: listSizeLimit} }}
            </agpr-message>
            <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
            <ul
                id="influencerStream_mentionList"
                class="agpr-influencerStream-cardList"
                *ngIf="!_stream.editing && !showWarningMessage"
                agprListKeyboardNavigation
                [list]="visibleMentions"
            >
                <li
                    #mentionsList
                    *ngFor="let mention of visibleMentions; let i = index;"
                    class="agpr-influencerStream-card-container agpr-contextMenu-parent"
                    [ngClass]="{selected : focusedMention?.id === mention.id}"
                    [attr.aria-labelledby]="'influencerStream.' + index + '.mentionHeadlineId.'+ i"
                    [attr.aria-setsize]="visibleMentions.length"
                    [attr.aria-posinset]="i + 1"
                    (keydown.enter)="selectMention(mention, false)"
                    (keydown.space)="selectMention(mention, false)"
                >
                    <span
                        [id]="'influencerStream.' + index + '.mentionHeadlineId.'+ i"
                        class="sr-only">
                            {{ mention.headline ?
                                    mention.headline :
                                    ('MediaType.'+ mention.mediaType.id | localize) +  ('Mention.postBy' | localize) +  mention.author.name
                            }}
                    </span>
                    <div class="agpr-influencerStream-card-container-contextMenu agpr-contextMenu top right">
                        @if (mention?.author?.uuid) {
                            <agpr-button
                                [icon]="'fa-regular fa-duotone fa-user-plus'"
                                (click)="openManageListDialog(mention)"
                                tooltip="Discover.targeting.actions.manageLists"
                                [style]="buttonTypes.contextMenu"
                            ></agpr-button>
                        }
                    </div>
                    <div
                        class="agpr-influencerStream-card"
                        [ngClass]="{'selected' : mention.selected}"
                        (agprClickUnless)="selectMention(mention, false)"
                        [agprClickUnlessSelectors]="['a', 'button']"
                    >
                        <div class="agpr-influencerStream-card-column">
                            <div class="agpr-influencerStream-card-author">
                                <div>
                                    <!-- TODO need to fetch these separately from targeting backend -->
                                    <img
                                        class="agpr-influencerStream-card-outletAvatar"
                                        alt=""
                                        [agprImageSrc]="mention.avatarUrl || mention.socialAvatarUrl"
                                        [agprDefaultImage]="imageDefault.SMALL_CONTACT"
                                    />
                                </div>
                                <div class="agpr-influencerStream-card-authorName">
                                    @if (!!mention.author.name) {
                                        <div>
                                            <a
                                                class="authorName"
                                                (click)="selectMention(mention, false)"
                                                tabindex="0"
                                                [agprTooltip]="'Mention.tooltip.contact'"
                                                tooltipPosition="top"
                                            >
                                                {{ mention.author.name }}
                                            </a>
                                            <span role="img" class="fa-solid fa-user icon"></span>
                                        </div>
                                    }

                                    @if (mention.publication.name && !mention.mediaType.isSocial) {
                                        <div
                                            class="outletName"
                                            [pTooltip]="mention.publication.name"
                                        >
                                            @if (mention.publication.uuid) {
                                                <agpr-button
                                                    [style]="buttonTypes.link"
                                                    [label]="mention.publication.name"
                                                    (click)="selectMention(mention, true)"
                                                ></agpr-button>
                                            } @else {
                                                <span class="outletName-noLink">
                                                    {{ mention.publication.name }}
                                                </span>
                                            }
                                        </div>
                                    }

                                    @if (mention?.twitterHandle && mention?.mediaType.id === mediaTypeEnum.TWITTER) {
                                        <a
                                            class="authorHandle"
                                            [href]="'http://x.com/' + mention.socialUrl"
                                            target="_blank"
                                            [agprInitiallyFocusable]="i === 0"
                                        >
                                            &#64;{{ mention.twitterHandle }}
                                        </a>
                                    } @else if (mention?.youtubeHandle && mention?.mediaType.id === mediaTypeEnum.YOUTUBE) {
                                        <a
                                            class="authorHandle"
                                            [href]="'https://www.youtube.com/' + mention.youtubeHandle"
                                            target="_blank"
                                            [agprInitiallyFocusable]="i === 0"
                                        >
                                            {{ mention.youtubeHandle }}
                                        </a>
                                    } @else if (mention?.blueskyHandle && mention?.mediaType.id === mediaTypeEnum.BLUESKY) {
                                        <a
                                            class="authorHandle"
                                            [href]="'https://bsky.app/profile/' + mention.blueskyHandle"
                                            target="_blank"
                                            [agprInitiallyFocusable]="i === 0"
                                        >
                                            &#64;{{ mention.blueskyHandle }}
                                        </a>
                                    }
                                </div>
                            </div>
                            <div>
                                @if (mention.isCla) {
                                    <img
                                        src="assets/images/cla.jpg"
                                        [alt]="'MediaType.cla.logo' | localize"
                                        class="agpr-mention-mediaTypeIcon agpr-influencerStream-card-mediaTypeIcon--cla"
                                        agprTooltip="MediaType.cla"
                                        tooltipPosition="left"
                                    />
                                }
                                @if (mention.isNla) {
                                    <img
                                        src="assets/images/nla.jpg"
                                        [alt]="'MediaType.nla.logo' | localize"
                                        class="agpr-mention-mediaTypeIcon agpr-influencerStream-card-mediaTypeIcon--nla"
                                        agprTooltip="MediaType.nla"
                                        tooltipPosition="left"
                                    />
                                }
                                @if (mentionLinksEnabled && !!mention.headline && mention.url) {
                                    <a
                                        [href]="mention.url"
                                        target="_blank"
                                        class="agpr-influencerStream-card-mentionHeadline"
                                        [innerHTML]="mention.headline ? (mention.headline | highlightKeywords: this.keywords) : '' "
                                    ></a>
                                } @else if (mentionLinksEnabled && !mention.headline && mention.url) {
                                    <a
                                        [href]="mention.url"
                                        target="_blank"
                                        class="agpr-influencerStream-card-mentionHeadline-mediaType"
                                        [innerHTML]="'Discover.influencerStreams.mediaType.' + mention.mediaType.id | localize"
                                    ></a>
                                } @else if ((!mentionLinksEnabled || !mention.url) && !!mention.headline) {
                                    <span
                                        class="agpr-influencerStream-card-mentionHeadline"
                                        [innerHTML]="mention.headline ? (mention.headline | highlightKeywords: this.keywords) : '' "
                                    ></span>
                                } @else {
                                    <span
                                        class="agpr-influencerStream-card-mentionHeadline-mediaType"
                                        [innerHTML]="'Discover.influencerStreams.mediaType.' + mention.mediaType.id | localize"
                                    ></span>
                                }
                                @if ((mention.isCla || mention.isNla) && !mention.url) {
                                    <span
                                        class="fa-solid fa-key agpr-influencerStream-card-mentionHeadline-mentionLockIcon"
                                        [agprTooltip]="'Mention.tooltip.unlock' | localize:{ licenseType: mention.isCla ? 'CLA' : 'NLA' }"
                                        (click)="unlockMentionClicked([mention])"
                                    ></span>
                                }
                            </div>
                            <div class="agpr-influencerStream-card-mentionBody">
                                @if (mention.mediaType.id === mediaTypeEnum.TWITTER) {
                                    <span
                                        [innerHTML]="mention.body | indexHighlight:mention.contexualKeywordIndices : this.keywords
                                        | mentionLinks:mention.mediaType.id
                                        | indexHighlightSup"
                                    ></span>
                                } @else {
                                    <span
                                        [innerHTML]="mention.body  | indexHighlight:mention.contexualKeywordIndices : this.keywords
                                        | mentionLinks:mention.mediaType.id
                                        | indexHighlightSup"
                                    ></span>
                                }
                            </div>
                        </div>
                    </div>

                    <div class="agpr-influencerStream-card-footer">
                        <!-- TODO : put this in?
                        *ngIf="!mention.isLexisNexis; else lexisNexisLogo"
                        -->
                        <span class="agpr-influencerStream-card-footer-left">
                            <span
                                role="img"
                                class="agpr-influencerStream-card-footer-mediaType"
                                [ngClass]="mention.mediaType.icon"
                                [agprTooltip]="mention.mediaType.tooltip"
                                tooltipPosition="top"
                            ></span>
                            <span class="agpr-influencerStream-card-timestamp">
                                {{ mention.relativeDateString }}
                            </span>
                        </span>
                        <div class="agpr-influencerStream-card-footer-right" *ngIf="mention.images?.length > 0">
                            <!-- This element is hidden from the SR because mention images
                                do not have alt text and therefore provide no value to non-visual users -->
                            <span
                                role="img"
                                class="fa-regular fa-duotone fa-image"
                                aria-hidden="true"
                                (click)="mention.imagesExpanded = !mention.imagesExpanded"
                            ></span>
                            <agpr-button
                                [style]="buttonTypes.icon"
                                [icon]="mention.imagesExpanded ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'"
                                (click)="mention.imagesExpanded = !mention.imagesExpanded"
                                class="agpr-influencerStream-card-footer-expandButton"
                                [ngClass]="{ 'agpr-influencerStream-card-footer-expandButton--expanded': mention.imagesExpanded }"
                                [ariaLabel]="mention.imagesExpanded ? 'Mention.collapse' : 'Mention.expand'"
                                [expanded]="mention.imagesExpanded"
                                [tooltip]="mention.imagesExpanded ? 'Mention.collapse' : 'Mention.expandImage'"
                                tooltipPosition="top"
                            ></agpr-button>
                        </div>
                    </div>

                    @if (mention.imagesExpanded && mention.images.length > 0) {
                        <img
                            class="agpr-influencerStream-card-image"
                            src="{{mention.images[0].source}}"
                            (error)="mention.images[0].source=undefined"
                            aria-hidden="true"
                            alt=""
                        />
                    }
                </li>
            </ul>
            <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
        </agpr-scroll-panel>
    }

</div>
